import { Component, Input, Output, EventEmitter } from '@angular/core';

import { IRestrictionSummaryEvent } from '../share';
import { SelectedRestrictionType } from './../share/restriction';

@Component({
  selector: 'app-restriction-summary',
  templateUrl: './restriction-summary.component.html',
  styleUrls: ['./restriction-summary.component.less'],
  standalone: false
})
export class RestrictionSummaryComponent {

  @Input() selectedRestrictionList: SelectedRestrictionType[] = [];
  @Input() showLabelAsHyperlink = false;

  @Input() cssGridClassValue = 'col-xs-8 col-lg-6';
  @Input() cssGridClassLabel = 'col-xs-4 col-lg-6';

  @Input() showInclusiveExclusive = true;

  @Output() restrictionTypeClick = new EventEmitter<IRestrictionSummaryEvent>();

  clickRestrictionType(item: SelectedRestrictionType) {
    this.restrictionTypeClick.emit({ id: item.RestrictionTypeId, code: item.RestrictionTypeCode });
  }
}

